var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "rgba(255,255,255,0.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 18.3711V27.5C27.5 28.0967 27.2629 28.669 26.841 29.091C26.419 29.5129 25.8467 29.75 25.25 29.75H14.75C14.1533 29.75 13.581 29.5129 13.159 29.091C12.7371 28.669 12.5 28.0967 12.5 27.5V12.5C12.5 11.9033 12.7371 11.331 13.159 10.909C13.581 10.4871 14.1533 10.25 14.75 10.25H19.3789C19.7766 10.2501 20.158 10.408 20.4392 10.6892L27.0608 17.3108C27.342 17.592 27.4999 17.9734 27.5 18.3711Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.625V16.25C20 16.6478 20.158 17.0294 20.4393 17.3107C20.7206 17.592 21.1022 17.75 21.5 17.75H27.125M16.25 21.5H23.75M16.25 25.25H23.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c482fb749f23ae4ae10f3a65a43d898e.svg";
export { ForwardRef as ReactComponent };